import type React from 'react'

import type { Recipient } from '@/types'
import { clsJoin } from '@/utils'
import { CommentContentEditor } from '../CommentContentEditor'
import { CommentHeader } from '../CommentHeader'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  author: Recipient | null
  /** Passed through to the header — see `CommentHeader`. */
  storedName: string | null
  content: string
  readOnly: boolean
  updatedAt: number
  createdAt: number
  onSubmit: (value: string) => void
  onCancel: () => void
  className?: string
}

export const ThreadComment: React.FC<Props> = ({
  content,
  children,
  onCancel,
  readOnly,
  onSubmit,
  author,
  storedName,
  updatedAt,
  createdAt,
  className = '',
}) => (
  <div className={clsJoin(css.thread_comment, className)}>
    <CommentHeader
      updatedAt={updatedAt}
      createdAt={createdAt}
      author={author}
      storedName={storedName}
    >
      {children}
    </CommentHeader>
    <div className={css.comment_body}>
      <CommentContentEditor
        onSubmit={onSubmit}
        value={content}
        readonly={readOnly}
        onCancel={onCancel}
      />
    </div>
  </div>
)
